module.exports = __webpack_public_path__ + "img/iv-jack.ae58a224.png";